module.exports = __webpack_public_path__ + "img/fan.9a0d515f.gif";